export default "__VITE_ASSET__Bd9P0ZXb__"